export const c_table__sticky_cell_MinWidth = {
  "name": "--pf-v6-c-table__sticky-cell--MinWidth",
  "value": "8.75rem",
  "var": "var(--pf-v6-c-table__sticky-cell--MinWidth)"
};
export default c_table__sticky_cell_MinWidth;